export default "__VITE_ASSET__6be6b718__"